import React from 'react';

// third-party
import PropTypes from 'prop-types';
import MobileMenu from './MobileMenu';

function mobilePanel() {
    return (
        <MobileMenu layout="default" />
    );
}

mobilePanel.propTypes = {
    layout: PropTypes.oneOf(['default', 'test']),
};

mobilePanel.defaultProps = {
    layout: 'default',
};

export default mobilePanel;
